module.exports = __webpack_public_path__ + "img/fondo-banner-principal.32228650.png";